import { TLiftedFormModel } from '../../model/form.model';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import * as _ from 'lodash';

export const BULK_UPDATE_PREVENTIVE_SCHEDULE_FORM_MODEL = {
  createModel: (): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'INPUT',
            subType: 'date',
            value: undefined,
            dateType: 'DATETIME',
          },
          metadata: {
            keyName: 'preventiveLastScheduledAt',
            label: 'Scheduled date',
            isRequired: true,
          },
        },
      ],
      isValid: false,
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};
